import { useMemo } from 'react';

import {
  AnyDocument,
  Evaluatable,
  WorkflowDataResolverDependencies,
} from '~/core/shared/types';
import { isEvaluatable } from '~/core/shared/utils/evaluatable';
import { useEvaluatableResolver } from '../useEvaluatableResolver';

export const useEvaluatedValue = (
  value: string | Evaluatable,
  workflowDataResolverDependencies?: Partial<WorkflowDataResolverDependencies>,
  parentContext?: AnyDocument,
) => {
  const evaluatableResolver = useEvaluatableResolver();

  const evaluatedValue = useMemo(() => {
    const resolvedValue = isEvaluatable(value)
      ? evaluatableResolver(
          value,
          workflowDataResolverDependencies,
          parentContext,
        )
      : value;

    // if evaluator fails we get a string "undefined"
    if (resolvedValue === 'undefined') {
      return undefined;
    }
    return resolvedValue;
  }, [
    value,
    workflowDataResolverDependencies,
    parentContext,
    evaluatableResolver,
  ]);

  return evaluatedValue;
};
